import i18n from "@/i18n";
import { SubscriberType } from "@/services/players/types";

export const subscribersFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType,
        sortable: true
    },
    {
        key: "email",
        label: i18n.t("common.email"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];

export const addSubscribersFields = [
    {
        key: "name",
        label: i18n.t("common.name")
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType
    },
    {
        key: "email",
        label: i18n.t("common.email")
    },
    {
        key: "access",
        label: ""
    }
];

// helper methods
function formatType(type: SubscriberType) {
    return i18n.t("playerMonitors." + SubscriberType[type].toString().toLowerCase());
}
